const __request = require(`./__request/__request_contentType_form`);
/**
 * 获取城市
 */
export default function (val) {
    var pParameter = {}
    pParameter.method = "POST"

    pParameter.urlSuffix = "/hotel/common/getCityList"
    pParameter.data = val
    return new Promise(function (resolve, reject) {
        resolve(__request(pParameter))
    })
}
